import { Directive, Input, OnDestroy, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { DurationRangeService } from '@app-core/services/duration-range/duration-range.service';
import { StartupService } from '@app-core/services/startup/startup.service';
import { getCurrentAccessDetailsState } from '@app-shared/reducers';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { State } from '@app-shared/reducers/user-permission.reducer';
import { Store } from '@ngrx/store';

@Directive({
  selector: '[appCheckFeatureFlag]',
})
export class CheckFeatureFlagDirective implements OnInit, OnDestroy {
  @Input('appCheckFeatureFlag') set checkPermissions(featueFlagConfig) {
    this.featueFlagPermissions = featueFlagConfig || [];
    this.updateView();
  }
  private ngUnsubscribe: Subject<void> = new Subject<void>();
  private featueFlagPermissions: string[] = [];
  public requiredFeatureFlag: string[] = [];

  constructor(
    public durationRangeService: DurationRangeService,
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private store: Store<State>,
    private startupService: StartupService
  ) {}

  public ngOnInit() {
    this.store
      .select(getCurrentAccessDetailsState)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(({ permissions = [] }) => {
        this.requiredFeatureFlag = permissions || [];
        this.updateView();
      });

    // Subscribe to clientConfig changes to re-evaluate when planDetails is updated
    // This ensures feature flags are correctly shown after admin portal redirect
    this.startupService.clientConfig.pipe(takeUntil(this.ngUnsubscribe)).subscribe(() => {
      this.updateView();
    });
  }
  public updateView() {
    const planDetails = this.durationRangeService.planDetails;
    if (!planDetails) {
      this.viewContainer.clear();
      this.viewContainer.createEmbeddedView(this.templateRef);
      return;
    }
    const featureFlags = planDetails?.featureFlags;
    const showFeature = this.featueFlagPermissions.every((val: string) => featureFlags.includes(val));
    if (showFeature) {
      this.viewContainer.clear();
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }

  public ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
